import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
const StoreSettings = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  return (
    <Dashboard title="Store">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6">
        <div className="w-full border shadow bg-white rounded-lg p-12 flex flex-col justify-center items-center">
          <Skeleton loading={loading}>
            <div className="text-center">
              <p className="text-xl font-bold mb-2">
                <a className="text-gray-700" href="/storeinfo">
                  Edit Store Info
                </a>
              </p>
              <p className="text-base text-gray-400 font-normal">
                Name, Country, Currency
              </p>
            </div>
          </Skeleton>
        </div>
        <div className="w-full border shadow bg-white rounded-lg p-12 flex flex-col justify-center items-center">
          <Skeleton loading={loading}>
            <div className="text-center">
              <p className="text-xl font-bold mb-2">
                <a className="text-gray-700" href="/shipping">
                  Add Shipping Methods
                </a>
              </p>
            </div>
          </Skeleton>
        </div>
        {/* <div className="w-full bg-white rounded-lg p-12 flex flex-col justify-center items-center">
            <Skeleton loading={loading}>
              <div className="text-center">
                <p className="text-xl font-bold mb-2">
                  <a className="text-gray-700" href="/storeinfo">
                    Add Payment Methods
                  </a>
                </p>
                <p className="text-base text-gray-400 font-normal">
                  Cash on delivery
                </p>
              </div>
            </Skeleton>
          </div> */}
      </div>
    </Dashboard>
  );
};

export default StoreSettings;
